import React, { useState } from "react";

// Image with a skeleton placeholder that stays visible until the image
// actually loads, plus one automatic retry on transient load failures.
export const SmartImage = ({ src, alt = "", className = "", imgClassName = "", testId, ...rest }) => {
  const [status, setStatus] = useState("loading"); // loading | loaded | error
  const [attempt, setAttempt] = useState(0);

  const finalSrc = attempt === 0 ? src : `${src}${src.includes("?") ? "&" : "?"}r=${attempt}`;

  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testId}>
      {status !== "loaded" && (
        <div className="absolute inset-0 animate-pulse bg-neutral-200" aria-hidden="true" />
      )}
      {src ? (
        <img
          src={finalSrc}
          alt={alt}
          loading="lazy"
          decoding="async"
          onLoad={() => setStatus("loaded")}
          onError={() => {
            if (attempt < 2) {
              setAttempt((a) => a + 1);
              setStatus("loading");
            } else {
              setStatus("error");
            }
          }}
          className={`${imgClassName} transition-opacity duration-500 ${status === "loaded" ? "opacity-100" : "opacity-0"}`}
          {...rest}
        />
      ) : null}
    </div>
  );
};

export default SmartImage;
